import React from "react";
import { useTranslation } from 'react-i18next';
import Chip from '@mui/material/Chip';
import jordimongeImage from '../assets/images/websites/jordimonge.jpg';
import sempliceImage from '../assets/images/websites/semplice.jpg';
import calantonImage from '../assets/images/websites/calanton.jpg';
import '../assets/styles/Websites.scss';

interface Website {
    id: string;
    url: string;
    image?: string; // optional: a placeholder with the site's initial is shown without it
    inDevelopment?: boolean;
    tags: string[];
}

// Add new sites here and their texts under "websites.items.<id>" in the locale files.
const websites: Website[] = [
    {
        id: 'jordimonge',
        url: 'https://www.jordimonge.com/',
        image: jordimongeImage,
        tags: ['Portfolio', 'Art', 'Multilingual'],
    },
    {
        id: 'semplice',
        url: 'https://semplicehr.com/',
        image: sempliceImage,
        tags: ['Backend', 'HR', 'SaaS'],
    },
    {
        id: 'calanton',
        url: 'https://calanton-opcio1.vercel.app/',
        image: calantonImage,
        inDevelopment: true,
        tags: ['React', 'TypeScript', 'Tailwind CSS'],
    },
];

function Websites() {
    const { t } = useTranslation();

    return (
        <div className="container" id="websites">
            <div className="websites-container">
                <h1>{t('websites.title')}</h1>
                <p className="websites-description">{t('websites.description')}</p>
                <div className="websites-grid">
                    {websites.map(site => (
                        <a
                            key={site.id}
                            className="website-card"
                            href={site.url}
                            target="_blank"
                            rel="noreferrer"
                        >
                            <div className="website-card__image">
                                {site.image ? (
                                    <img
                                        src={site.image}
                                        alt={t(`websites.items.${site.id}.title`)}
                                        loading="lazy"
                                    />
                                ) : (
                                    <span className="website-card__placeholder" aria-hidden="true">
                                        {site.id.charAt(0).toUpperCase()}
                                    </span>
                                )}
                                {site.inDevelopment && (
                                    <span className="website-card__badge">{t('websites.inDevelopment')}</span>
                                )}
                            </div>
                            <div className="website-card__body">
                                <h3>{t(`websites.items.${site.id}.title`)}</h3>
                                <span className="website-card__url">{new URL(site.url).hostname.replace(/^www\./, '')} ↗</span>
                                <p>{t(`websites.items.${site.id}.description`)}</p>
                                <div className="website-card__tags">
                                    {site.tags.map(tag => (
                                        <Chip key={tag} className="chip" label={tag} />
                                    ))}
                                </div>
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Websites;
